import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { useCapacitor } from '../../../hooks/useCapacitor';
import { useQuery } from '../../../hooks/useQuery';
import { Footer } from '../../components/Footer/Footer';
import { FullscreenLoader } from '../../components/FullscreenLoader/FullscreenLoader';
import { LoginForm } from '../../components/LoginForm/LoginForm';
import { Topbar } from '../../components/Topbar/Topbar';
import { getPublicResourcesBaseUrl, verifyHashedQueryParams } from '../../utils/utils';
import styles from './Home.module.scss';

const HomeComponent = () => {
  const { isLoggedIn, requestImpersonationToken, loginWithToken } = useFirebase();
  const { isNative } = useCapacitor();
  const history = useHistory();
  const { logout, uid, sender, token, redirectTo } = useQuery();
  const { t } = useTranslation();

  useEffect(() => {
    if (isLoggedIn && !logout) history.replace('/browse');
  }, [isLoggedIn]);

  if (['localhost:3002', 'impersonate.tootor.it'].includes(window.location.host)) {
    sessionStorage.clear();
    if (!uid || !sender || !token) window.location.href = 'https://app.tootor.it';
    verifyHashedQueryParams({ uid, sender, token }).then((valid) => {
      if (!valid) window.location.href = 'https://app.tootor.it';
      else requestImpersonationToken(uid, sender).then(loginWithToken).catch(console.error);
    });
    return <FullscreenLoader />;
  }

  if (logout) return <FullscreenLoader />;

  if (isNative && !isLoggedIn && !logout) return <LoginForm showCancel={false} />;

  return (
    <div className={styles.lpPageWrapper}>
      <Topbar showLoginButtonIfNeeded={false} />

      <main className={styles.loginPage}>
        <section className={`${styles.loginCard} surface-card`}>
          <h1 className="text-page-title">{t('loginModal.labels.effettuaAccesso')}</h1>
          <LoginForm showCancel={false} showSignup redirectTo={redirectTo} />
        </section>
      </main>

      <div className={styles.lpFooter}>
        <Footer />
      </div>
    </div>
  );
};

export default HomeComponent;
